import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'durationMinutes',
    standalone: false
})

export class DurationMinutesPipe implements PipeTransform {
    transform(totalMinutes: number | null | undefined): string {
        if (totalMinutes === null || totalMinutes === undefined || isNaN(totalMinutes as any)) {
            return '';
        }

        const minutes = Math.floor(totalMinutes);
        const minutesInDay = 24 * 60;
        const minutesInHour = 60;

        const days = Math.floor(minutes / minutesInDay);
        const hours = Math.floor((minutes % minutesInDay) / minutesInHour);
        const remainingMinutes = minutes % minutesInHour;

        const parts: string[] = [];

        if (days > 0) {
            parts.push(`${days} day${days === 1 ? '' : 's'}`);
        }

        if (hours > 0) {
            parts.push(`${hours} hour${hours === 1 ? '' : 's'}`);
        }

        if (remainingMinutes > 0 || parts.length === 0) {
            parts.push(`${remainingMinutes} minute${remainingMinutes === 1 ? '' : 's'}`);
        }

        return parts.join(' ');
    }
}

